module.exports = __webpack_public_path__ + "img/20190810114808407.d48a7648.png";